import allImgPaths from 'assets/images';
import React, { useState, useEffect, useRef } from 'react';

const ResizableImage = ({ imageData, index, onResize }: any) => {
  const imgRef = useRef<any>(null);
  const [imageSrc, setImageSrc] = useState<any>('')

  useEffect(() => {
    if (!imageData?.isEditMode) {
      setImageSrc(imageData?.content?.previewUrl)
    } else {
      if (imageData?.content?.isNewImageUploaded) {
        setImageSrc(imageData?.content?.previewUrl)
      } else {
        if (imageData?.content?.imageUrl == imageData?.content?.originalImageUrl) {
          setImageSrc(imageData?.content?.previewUrl)
        } else {
          setImageSrc(imageData?.content?.imageUrl)
        }
      }
    }
  }, [imageData?.updatedTime])

  useEffect(() => {
    const handleResize = () => {
      if (imgRef.current) {
        onResize(index, {
          width: imgRef.current.clientWidth,
          height: imgRef.current.clientHeight,
        });
      }
    };

    const observer = new ResizeObserver(handleResize);
    if (imgRef.current) {
      observer.observe(imgRef.current);
    }

    return () => {
      if (imgRef.current) {
        observer.unobserve(imgRef.current);
      }
    };
  }, [index, onResize]);

  const setDefaultImage = (event: any) => {
    event.target.src = allImgPaths.defaultProfile
  }

  return (
    <>
      {
        imageSrc &&
        <div
          className='resize overflow-auto max-w-[222px] max-h-[222px] w-[222px] h-[222px]'
          style={{ width: imageData?.content?.width, height: imageData?.content?.height }}
        >
          <img
            ref={imgRef}
            className="w-full h-full object-cover rounded border border-[#ddd]"
            src={imageSrc}
            alt=""
            onError={setDefaultImage}
            loading='lazy'
          />
        </div>
      }
    </>
  );
};

export default ResizableImage;
